import { Avatar } from '@tempmee/react';
import { SolidHeartIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Colors } from '../../../../themes/colors';
import { BestPickLabel } from './BestPickLabel';

export const CollapsibleCandidateCard = ({
  item,
  onClick,
  isSelected = false,
  isBestPick,
  containerStyle,
}) => (
  <div
    style={{
      backgroundColor: isSelected ? colors.shades[0] : Colors.neutral_50,
      boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.15)',
      width: 208,
      height: 60,
      cursor: 'pointer',
      ...containerStyle,
    }}
    onClick={onClick}
  >
    <div
      style={{
        position: 'relative',
        height: 4,
        backgroundColor: isSelected ? colors.secondary[500] : 'transparent',
        width: 'calc(100% + 2px)',
        marginLeft: -1,
      }}
    >
      {/* {isBestPick && <BestPickLabel />} */}
    </div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        paddingTop: 4,
        paddingLeft: 16,
      }}
    >
      <div
        style={{
          position: 'relative',
          border: `3px solid ${item?.isFavorite ? colors.favorites[400] : 'transparent'}`,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
        }}
      >
        <Avatar size="sm" src={item?.candidate?.profile_image || undefined} alt="profile_image" />
        {item?.isFavorite && (
          <div style={{ position: 'absolute', top: '62%', right: -2 }}>
            <SolidHeartIcon color={colors.favorites[400]} width={14} />
          </div>
        )}
      </div>

      <b
        style={{
          fontSize: 16,
          color: colors.neutral[600],
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 130,
        }}
      >
        {`${item?.candidate?.first_name} ${item?.candidate?.last_name}`}
      </b>
    </div>
  </div>
);
